"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Button = function Button(props) {
  var icon = props.icon,
      iconStyles = props.iconStyles,
      reverse = props.reverse,
      text = props.text,
      title = props.title,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      onClick = props.onClick,
      returnValue = props.returnValue,
      disabled = props.disabled;

  var handleClick = function handleClick(e) {
    return onClick(returnValue, e);
  };

  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    title: title,
    className: (0, _classnames["default"])("btn ".concat(className), {
      reverse: reverse
    }),
    onClick: handleClick,
    disabled: disabled
  }, text, " ", icon && /*#__PURE__*/_react["default"].createElement("i", {
    className: icon,
    style: iconStyles
  }));
};

Button.propTypes = {
  icon: _propTypes["default"].string,
  text: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  className: _propTypes["default"].string,
  returnValue: _propTypes["default"].any,
  disabled: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  iconStyles: _propTypes["default"].object,
  reverse: _propTypes["default"].bool
};
var _default = Button;
exports["default"] = _default;